<div id="student-profile" class="profile">
  <div class="profile-container" [class.is-mobile]="isMobile">
    <app-header
      (height)="onGetHeight($event)"
      [sideNav]="matSidenav"
    ></app-header>
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav
        id="student-sidenav"
        *ngIf="showSideNav"
        #calendarNav
        [mode]="isMobile ? 'over' : 'side'"
        [fixedInViewport]="isMobile"
        [fixedTopGap]="headerHeight"
        [opened]="!isMobile"
      >
        <!-- <app-sidenav type="student-zone" [sideNav]="calendarNav"></app-sidenav> -->

        <!-- Start Labels -->
        <div class="labels margin-top-1" *ngIf="showLabels">
          <div class="title margin-bottom-05">{{ "labels" | translate }}</div>
          <div *ngFor="let label of labels" class="label">
            <div
              class="ball"
              [ngStyle]="{ 'background-color': label.color }"
            ></div>
            <div>{{ label.title | translate }}</div>
          </div>
        </div>
        <!-- End Labels -->
      </mat-sidenav>

      <mat-sidenav-content>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>

<app-loading [loading]="loading"></app-loading>
